module.exports = __webpack_public_path__ + "br.svg?eab91a4977926cfa795ddb23f9805032";


//////////////////
// WEBPACK FOOTER
// ./src/images/flags/1x1/br.svg
// module id = 957
// module chunks = 27